export default {"src":"/_next/static/media/Group-25838.d217f795.svg","height":104,"width":104};